import { useEffect, useState, ReactElement, useCallback } from 'react';
import { Pagination } from 'antd';
import { renderRacesContent } from 'app/components/templates/races/races';
import { _isEmpty } from 'app/utils/helpers';
import PageWithLoader from 'app/hoc/page_with_loader/page_with_loader';
import { useCompare } from 'app/hooks';
import modalsSlice from 'app/store/modals/modals.slice';
import 'app/components/templates/races/races.scss';
import { useGetRaces } from 'app/utils/api/queries/races.query';
import racesSlice from 'app/store/races/races.slice';

const PastRaces = (): ReactElement => {
    const { updatePageNumber, races: racesState } = racesSlice((state) => state);
    const { currentPage } = racesState.past;

    const { data: pastRaces, isLoading } = useGetRaces({
        filter: 'past',
        page: currentPage,
    });

    const { page_size, results, count } = pastRaces ?? {};
    const { toggleImportRaceModal } = modalsSlice((state) => state);
    const [isPaginated, setIsPaginated] = useState<boolean>(false);

    const paginationHandler = useCallback(
        (page: number) => {
            window.scrollTo(0, 0);
            setIsPaginated(true);
            updatePageNumber('past', page);
        },
        [updatePageNumber]
    );

    const didRacesChange = useCompare(results?.length);

    // go back to previous page when last item on the page is deleted
    useEffect(() => {
        if (didRacesChange && currentPage > 1 && _isEmpty(results)) {
            paginationHandler(currentPage - 1);
        }
    }, [results, currentPage, paginationHandler, didRacesChange]);

    const showPagination = !!count && !!page_size && count > page_size;

    return (
        <PageWithLoader isLoading={isLoading && !isPaginated}>
            <div className={`races__wrap ${isLoading ? 'isLoading' : ''}`}>
                <div className={`races__inner-wrap ${results?.length === 0 ? 'noRaces' : ''}`}>
                    {results && renderRacesContent(results, 'past', toggleImportRaceModal)}
                </div>
                {showPagination && (
                    <div className='races__pagination'>
                        <Pagination
                            onChange={(page: number) => paginationHandler(page)}
                            current={currentPage}
                            total={count}
                            pageSize={page_size}
                            showTitle
                            showSizeChanger={false}
                        />
                    </div>
                )}
            </div>
        </PageWithLoader>
    );
};

export default PastRaces;
